<div class="dialog-default">
    <h1 *ngIf="data.title" mat-dialog-title>{{data.title}}</h1>
    <p *ngIf="data.message">{{data.message}}</p>
    <div class="d-flex flex-row justify-content-end">
        <button (click)="Fermer()" class="btn btn-primary my-2 mx-2" type="button">Fermer</button>
    </div>
</div>
